import { Injectable } from '@angular/core';
import { NotificationService, EndpointsService, DateHelperService } from "../core/services/index";
import { Http, Response, RequestOptions, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { ReportTypes } from "./reports.enum";
import { FileType } from "../shared/filetype.enum";

@Injectable()
export class ReportsService {
    private static notificationService;
    constructor(
        private http: Http,
        private endpointsService: EndpointsService,
        private notificationService: NotificationService,
        private dateHelper: DateHelperService) {
        ReportsService.notificationService = notificationService;
    }

    public getRevenueReports(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, startDateUtc: Date, endDateUtc: Date): Observable<Response> {
        let startDate = this.dateHelper.formatDate(startDateUtc);
        let endDate = this.dateHelper.formatDate(endDateUtc);
        let url = `${this.endpointsService.GET_REVENUE_REPORTS}?sortField=${sortFieldId}&sortAsc=${sortAsc}&pageNumber=${pageNumber}&pageSize=${pageSize}&startDateUtc=${startDate}&endDateUtc=${endDate}`;
        return this.http.get(url).catch(this.handleError);
    }

    public getFillReports(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, startDateUtc: Date, endDateUtc: Date): Observable<Response> {
        let startDate = this.dateHelper.formatDate(startDateUtc);
        let endDate = this.dateHelper.formatDate(endDateUtc);
        let url = `${this.endpointsService.GET_FILL_REPORTS}?sortField=${sortFieldId}&sortAsc=${sortAsc}&pageNumber=${pageNumber}&pageSize=${pageSize}&startDateUtc=${startDate}&endDateUtc=${endDate}`;
        return this.http.get(url).catch(this.handleError);
    }

    public generateReportFile(startDateUtc: Date, endDateUtc: Date, name: string, reportType: ReportTypes, fileType: FileType): Observable<Blob>{
        let startDate = this.dateHelper.formatDate(startDateUtc);
        let endDate = this.dateHelper.formatDate(endDateUtc);
        let options = new RequestOptions({ responseType: ResponseContentType.Blob });
        return this.http.get(`${this.endpointsService.GENERATE_REPORT}?reportType=${reportType}&fileType=${fileType}&startDateUtc=${startDate}&endDateUtc=${endDate}&name=${name}`, options)
            .map(res => res.blob())
            .catch(this.handleError);
    }

    public getLatestSavedReports(): Observable<Response> {
        return this.http.get(this.endpointsService.GET_LATEST_SAVED_REPORTS).catch(this.handleError);
    }

    private handleError(error: Response) {
        if (error.status === 400)
            ReportsService.notificationService.showError(error.json().message)
        else
            ReportsService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/reports.service.ts